import { Modal } from './modal.js'
import { Calendar } from '@fullcalendar/core';
import resourceTimelineWeek from '@fullcalendar/resource-timeline';
import deLocale from '@fullcalendar/core/locales/de';

class BVKCalendar {
    _targetItemId = ''
    _initialView = ''
    _resourceUri = ''
    _resourceList = []
    _eventUri = ''
    _dialog = {}
    _isLoggedIn = false;
    _isAdmin = false;
    _userId = "";
    _data = null;

    /**
     * 
     * @param {object} props 
     * @param {string} props.targetItemId 
     * @param {string} props.resourceUri 
     * @param {string} props.resourceList 
     * @param {string} props.eventUri 
     * @param {string} props.initialView 
     * @param {object} props.dialogOptions 
     * @param {string} props.dialogOptions.domId 
     * @param {object} props.dialogOptions.options 
 
     * @param {object} props.dialogOptions2 
     * @param {string} props.dialogOptions2.domId 
     * @param {object} props.dialogOptions2.options 
 
     * @param {boolean} props.isLoggedIn
     * @param {boolean} props.isAdmin
     * @param {string} props.userId
     * @param {object} props.data
     */
    constructor(props) {
        this._targetItemId = props.targetItemId || 'calendar';
        this._resourceUri = props.resourceUri || null;
        this._resourceList = props.resourceList || null;
        this._eventUri = props.eventUri;
        this._initialView = props.initialView || 'resourceTimelineWeek';
        this._dialog = new Modal(props.dialogOptions);
        this._dialog2 = new Modal(props.dialogOptions2);
        this._isLoggedIn = props.isLoggedIn || false;
        this._isAdmin = props.isAdmin || false;
        this._userId = props.userId || false;
        this._data = props.data || null;
    }
    get Resources() {
        if (this._resourceUri == null) return this._resourceList;
        return this._resourceUri;
    }
    init = (targetItemId) => {
        try {
            const targetId = targetItemId || this._targetItemId;
            const calendarEl = document.getElementById(targetId);
            const calendar = new Calendar(calendarEl, {
                plugins: [resourceTimelineWeek],
                initialView: 'resourceTimelineWeek',
                locale: deLocale,
                timeZone: 'UTC',
               resourceAreaWidth: "30%",
                resources: this.Resources,
                events: this._eventUri,
                resourceOrder: "number",
                dateClick: this.dateClick,
                eventClick: this.eventClick,
                slotMinTime: "08:00:00",
                slotMaxTime: "23:00:00",
                schedulerLicenseKey: '0366132045-fcs-1638443135'

            });
            calendar.render();
            calendar.updateSize();
            try {


                document.getElementsByClassName("fc-today-button")[0].addEventListener("click", () => {
                    setTimeout(
                        () => {
                            let date = new Date();
                            let month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
                            let dateString = date.getFullYear() + "-" + month + "-" + date.getDate();
                            document.querySelector("[data-date^='" + dateString + "']").scrollIntoView({ block: 'nearest', inline: 'center' })

                        }, 200);
                })
            } catch (e) {
                console.error(e);
            }
            this._instance = calendar;
            try {
                setTimeout(
                    () => {
                        let date = new Date();
                        let month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
                        let dateString = date.getFullYear() + "-" + month + "-" + date.getDate();
                        document.querySelector("[data-date^='" + dateString + "']").scrollIntoView({ block: 'nearest', inline: 'center' })

                    }, 500);
            } catch (e) {
                console.error(e);
            }
        } catch (error) {
            console.error(error);
        }
    }


    dateClick = async (info) => {
        if (!this._isLoggedIn && !this._isAdmin) return;
        if (!this._isAdmin && info.resource.id == "11000000-0000-0000-0000-000000000000") return;
        const dateOptions = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
        this._dialog.open(info);
    }
    eventClick = async (info) => {
        if (!this._isLoggedIn && !this._isAdmin) return;
        this._data.addEndpoint("bookings/" + info.event.id);
        this._data.getData('bookings/' + info.event.id).then(booking => {
            if (!this._isAdmin && booking.createdBy.id != this._userId) return;
            // console.log(booking);
            info.booking = booking;
            this._dialog2.open(info);
        })
        /*
        // window.open('/forms/booking/delete/'+ info.event.id)
        if (confirm('Moechten sie den Termin wirklich loeschen?'))
            window.open('/forms/booking/delete/' + info.event.id);
        console.log(info)*/





    }

}

export { BVKCalendar }
